/**
 * Created by mauget on 1/20/16.
 */

import $ from 'jquery';
import { View }         from 'backbone';
import { Model }        from 'backbone';
import eventBus         from 'EventBus.js';
import undoService      from 'UndoService.js';
import contentTemplate  from 'designer/layout-menu.ejs';
import crudController           from 'CrudController.js';
import pageCaptureController    from 'PageCaptureController.js';
import listService              from 'ListService.js';
import alignmentController      from 'AlignmentController.js';
import constants                from 'Constants';
import BaseMenuView             from 'BaseMenuView';
import userService              from 'UserService';
import util                     from 'util/Util';
import textUtil                 from 'util/TextUtil';
import formService from 'FormService';

//=================================================================================================
//
// An instance forms BackBone view of the menubar used atop the various layout panels.
//
// Lou Mauget, January 20, 2016
//
// Search on MENU in comments to find this file.
// (Of course if you're reading this, then you found the file)
//
//=================================================================================================
class LayoutMenuView extends BaseMenuView {

    initialize( opts ) {
        super.initialize();
        this.options = opts || {};
        this.template   = contentTemplate;

        // Click the three main views navigable within the normal designer main.
        // (Reports entered from the Dashboard)
        this.events = {
            'click #btnEditor'      : 'gotoEditor',
            'click #btnBehaviors'   : 'gotoBehaviors',
            'click #btnWorkflow'    : 'gotoWorkflow',
            'click #designerClose'  : 'closeForm',
            'click #designerNew'    : 'newFormRemote',
            'click #designerSave'   : 'saveForm',
            'click #designerSaveNewVersion' : 'saveFormNewVersion',
            'click #designerSaveNewForm'    : 'saveFormAsNew',
            'click #designerPublish'        : 'publish',
            'click #designerPreview'        : 'preview',
            'click #designerDebug'        : 'debug',
            'click #designerCopy'   : 'copyItem',
            'click #designerCut'    : 'cutItem',
            'click #designerPaste'  : 'pasteItem',
            'click #designerUndo'   : 'undo',
            'click #designerRedo'   : 'redo',
            'click #designerDelete' : 'deleteItem',
            'click #designerSelectAll'  : 'selectAll',
            'click #designerAlignTop'   : 'alignTop',
            'click #designerAlignBottom': 'alignBottom',
            'click #designerAlignLeft'  : 'alignLeft',
            'click #designerAlignRight' : 'alignRight',
            'click #designerVerticalCenter'     :'verticalCenter',
            'click #designerHorizontalCenter'   :'horizontalCenter',
            'click #designerResetSnapToGrid'    :'resetSnapToGrid',
            'click #designerSameWidth'  : 'makeSameWidth',
            'click #designerSameHeight' : 'makeSameHeight',
            'click #designerSameSize'   : 'makeSameSize',
            'click #designerSpaceEvenlyAcross'  : 'makeSpaceEvenlyAcross',
            'click #designerSpaceEvenlyDown'    : 'makeSpaceEvenlyDown',
            'click #designerSpaceEvenlyBoth'    : 'makeSpaceEvenlyBoth',
            'click #designerLayerTop'   : 'makeLayerTop',
            'click #designerLayerUp'    : 'makeLayerUp',
            'click #designerLayerDown'  : 'makeLayerDown',
            'click #designerLayerBottom': 'makeLayerBottom',

            'click #hideGrid':'toggleGridVisibility',
            'click #designerNonVisualObjects':'designerNonVisualObjects',
            'click #designerWorkflowMarkers':'designerWorkflowMarkers',
            'click #designerObjectMarkers':'designerObjectMarkers',
            'click #designerSnapToGrid':'toggleSnapToGrid',
            'click #designerSnapTextToNeighbor':'designerSnapTextToNeighbor',
            'click #designerToolbar':'designerToolbar',
            'click #designerPropertyBar':'designerPropertyBar',
            'click #designerHelpCenter':'designerHelpCenter',
            'click #pf-close-main-view':'closeForm'
        };

        this.setOptions(opts);
        this.listenTo(this.model, 'change', this.render);

        //undoService.setCallback(this.undoNotify);
        return this;
    }

    setOptions(){
        this.model.set('helpUrl', constants.HELP_URL);
        this.model.set('designerSnapToGrid', userService.userSettings.attributes._edAl !== '0');

        if(userService.userSettings.attributes._edShWfM===''){
            userService.userSettings.attributes._edShWfM=textUtil.stringToBoolean(this.model.get('designerSnapTextToNeighbor'));
        }

        this.model.set('designerSnapTextToNeighbor', util.isTrue(userService.userSettings.attributes._edShWfM));


        if(userService.userSettings.attributes._edShSM===''){
            userService.userSettings.attributes._edShSM=textUtil.stringToBoolean(this.model.get('designerObjectMarkers'));
        }
        this.model.set('designerObjectMarkers', util.isTrue(userService.userSettings.attributes._edShSM));

        if(userService.userSettings.attributes._edShNV===''){
            userService.userSettings.attributes._edShNV=textUtil.stringToBoolean(this.model.get('designerNonVisualObjects'));
        }

        this.model.set('designerNonVisualObjects', util.isTrue(userService.userSettings.attributes._edShNV));

        if(userService.userSettings.attributes._edShGrid===''){
            userService.userSettings.attributes._edShGrid=textUtil.stringToBoolean(this.model.get('hideGrid'));
        }
        this.model.set('hideGrid', textUtil.stringToBoolean(userService.userSettings.attributes._edShGrid));

        this.model.set('designerWorkflowMarkers', util.isTrue( userService.userSettings.attributes[constants.WORKFLOW_MARKERS] ));
        
    }

    undoNotify(e) {
        //console.log(e);
        //$('#designerUndo').addClass('disabled pf-disable');
    }

    toggleMenuStatusText(event,text){
        let currentElement=$(event.target);
        const id=currentElement.attr('id');

        if (currentElement.parent().html().includes('Off')) {
            this.model.set(id, true, {silent: true});
            currentElement.parent().html(`<a  id="${currentElement.attr('id')}">${text} - On</a>`);
        }
        else {
            this.model.set(id, false, {silent: true});
            currentElement.parent().html(`<a  id="${currentElement.attr('id')}">${text} - Off</a>`);
        }
    }



    designerNonVisualObjects(event){
        let value=util.isTrue(userService.userSettings.attributes._edShNV);
        userService.userSettings.attributes._edShNV=value===false ? true : false;
        this.model.set('designerNonVisualObjects', value, {silent:true});

        this.toggleMenuStatusText(event,'Non-Visual Objects');
    }

    designerObjectMarkers(event){
        let value=util.isTrue(userService.userSettings.attributes._edShSM);
        userService.userSettings.attributes._edShSM=!value;
        listService.objectList.map(object=>{
            if(!value) {
                object.showBages();
            }
            else{
                object.hideBages();
            }
        });
        this.toggleMenuStatusText(event,'Object Markers');
    }

    designerWorkflowMarkers(event){
        this.toggleMenuStatusText(event,'Workflow Markers');
        userService.userSettings.attributes[constants.WORKFLOW_MARKERS] = !userService.userSettings.attributes[constants.WORKFLOW_MARKERS];
    }

    designerSnapTextToNeighbor(event){
        this.toggleMenuStatusText(event,'Snap Text to Neighbor');

        let value=util.isTrue(userService.userSettings.attributes._edShWfM);
        userService.userSettings.attributes._edShWfM=!value;
        listService.snapToNeighbor=userService.userSettings.attributes._edShWfM;
    }

    designerToolbar(event){
        this.toggleMenuStatusText(event,'Toolbar');
    }

    designerPropertyBar(event){
        this.toggleMenuStatusText(event,'Property Bar');
    }

    designerHelpCenter(event){
        util.openHelpCenter(listService.mainKind, true);
    }

    closeForm(ev){
        if (undoService.hasChanges()) { 
            ev.preventDefault();
            ev.returnValue = false; 
            util.removeIfRemainingHelpCenter();                       
            formService.confirmSaveOnClose(); 
        }
        else {
            ev.preventDefault();
            ev.returnValue = false;              
            util.removeIfRemainingHelpCenter();    
            Backbone.history.loadUrl('close');
        }
    }

    alignTop(event){
        event.preventDefault();
        alignmentController.alignTop(listService.selected);
    }

    alignBottom(event){
        event.preventDefault();
        alignmentController.alignBottom(listService.selected);
    }

    alignLeft(event){
        event.preventDefault();
        alignmentController.alignLeft(listService.selected);
    }

    alignRight(event){
        event.preventDefault();
        alignmentController.alignRight(listService.selected);
    }

    verticalCenter(event){
        event.preventDefault();
        alignmentController.alignCenter(listService.selected,constants.ALIGN_VERTICAL);
    }

    horizontalCenter(event){
        event.preventDefault();
        alignmentController.alignCenter(listService.selected,constants.ALIGN_HORIZONTAL);
    }

    makeSameWidth(event){
        event.preventDefault();
        alignmentController.makeSameWidth(listService.selected);
    }

    makeSameHeight(event){
        event.preventDefault();
        alignmentController.makeSameHeight(listService.selected);
    }

    makeSameSize(event){
        event.preventDefault();
        alignmentController.makeSameWidth(listService.selected);
        alignmentController.makeSameHeight(listService.selected);
    }

    makeSpaceEvenlyAcross(event){
        event.preventDefault();
        alignmentController.spaceEvenly(listService.selected,constants.EVENLY_ACROSS);
    }

    makeSpaceEvenlyDown(event){
        event.preventDefault();
        alignmentController.spaceEvenly(listService.selected,constants.EVENLY_DOWN);
    }

    makeSpaceEvenlyBoth(event){
        event.preventDefault();
        alignmentController.spaceEvenly(listService.selected,constants.EVENLY_ACROSS);
        alignmentController.spaceEvenly(listService.selected,constants.EVENLY_DOWN);
    }

    makeLayerTop(event){
        event.preventDefault();
        alignmentController.toTop( listService.selected );
    }

    makeLayerBottom(event){
        event.preventDefault();
        alignmentController.toTop( listService.selected );
    }
    
    makeLayerUp(event){
        event.preventDefault();
        alignmentController.layerElement( listService.selected ,constants.LAYER_UP);

    }

    makeLayerDown(event){
        event.preventDefault();
        alignmentController.layerElement( listService.selected ,constants.LAYER_DOWN);
    }



    newFormRemote() {
        Backbone.history.loadUrl('addForm');
    }

    goDashboard() {
        Backbone.history.loadUrl('dashboard');
    }

    toggleGridVisibility(event){
        let currentElement=$(event.target);
        if (currentElement.parent().html().includes('Off')) {
            userService.userSettings.attributes._edShGrid = true;
            //this.model.set('hideGrid',true,{silent:true});
            eventBus.trigger('gridSizeSet', userService.userSettings.attributes._edShGrid);
            currentElement.parent().html(`<a  id="hideGrid">Grid - On</a>`);
        } else {
            userService.userSettings.attributes._edShGrid = false;
            //this.model.set('hideGrid',false,{silent:true});
            eventBus.trigger('gridSizeSet', userService.userSettings.attributes._edShGrid);  // TODO No hardcoding. Use and form gridWidth and gridHeight
            currentElement.parent().html(`<a  id="hideGrid"> Grid - Off</a>`);
        }
        pageCaptureController.captureThumbnail();
    }

    gotoEditor() {
        Backbone.history.loadUrl('edit');
    }

    gotoBehaviors() {
        Backbone.history.loadUrl('behaviors');
    }

    gotoWorkflow() {
        Backbone.history.loadUrl('workflow');
    }

    copyItem() {
        crudController.copySelected();
    }

    pasteItem() {
        crudController.pasteSelected();
    }

    cutItem() {
        crudController.cutSelected();
    }

    deleteItem() {
        if (listService.selectedCount) {
            crudController.deleteSelected();
        } else {
            crudController.deletePage();
        }
    }

    toggleSnapToGrid(event) {
        const $menuItem = $( '#designerSnapToGrid' ), prfSet = 'Set', prfReset = 'Reset';
        userService.userSettings.attributes._edAl = userService.userSettings.attributes._edAl === '0' ? '1' : '0';

        listService.snapToGrid = userService.userSettings.attributes._edAl === '0' ? false : true;
        this.model.set('designerSnapToGrid', listService.snapToGrid, {silent:true});
        $menuItem.html(`${listService.snapToGrid ? prfSet : prfReset } Snap-to-Grid -${listService.snapToGrid ? "On": "Off"}`);
        //listService.userSettings.attributes['_edAl'] = listService.snapToGrid? '1' :'0';
    }


    selectAll() {
        crudController.selectAll();
    }


    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.off();

        $('[data-submenu]').remove();
        
        this.$el.empty();
        super.remove();
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));


        // Enabling Submenu Functionality
        $('[data-submenu]').submenupicker();

        // Disabling menu items at first glance.
        $('#align').addClass('disabled pf-disable');
        $('#makeSame').addClass('disabled pf-disable');
        $('#spaceEvenly').addClass('disabled pf-disable');
        $('#layer').addClass('disabled pf-disable');
        $('#designerAddGroup').addClass('disabled pf-disable disabledLink');
        $('#designerUndo').addClass('disabled pf-disable disabledLink');
        $('#designerRedo').addClass('disabled pf-disable disabledLink');
        $('#designerCut').addClass('disabled pf-disable disabledLink');
        $('#designerCopy').addClass('disabled pf-disable disabledLink');
        $('#designerPaste').addClass('disabled pf-disable disabledLink');
        $('#designerDelete').addClass('disabled pf-disable disabledLink');

        this.setUndoRedoAccess();

        if (listService.selectedCount === 1) {
            const obj = listService.getObject( listService.currentId );
            if (obj && obj.model.attributes.factoryKey === 'control_group') {
                $('#designerAddGroup').text('Remove Group');
            }
        }

        this.delegateEvents();

        return this;
    }

}

export default LayoutMenuView;
